import Vue from 'vue'
import VueRouter, { Route } from 'vue-router'
import { BehaviorSubject, Subject } from 'rxjs'
import Login from '@/pages/Login.vue'
import OTPVerify from '@/pages/OTPVerify.vue'
import ApplicationCallinError from '@/pages/error/ApplicationCallinError.vue'
import ApplicationCompleted from '@/pages/ApplicationCompleted.vue'
import ApplicationFailed from '@/pages/ApplicationFailed.vue'
import InsureEmptyRouter from '@/pages/Insure/InsureEmptyRouter.vue'
import DispatchEmptyPage from '@/pages/DispatchEmptyPage.vue'
import ApplicationTimeout from '@/pages/ApplicationTimeout.vue'

Vue.use(VueRouter)
Vue.prototype.beforeEnter$ = new BehaviorSubject<{ to: Route, from: Route }>(null);
const routes = [

	/* ----------------------------------- 首頁 ------------------------------------- */
  {
    path: '/',
    name: 'index',
		component: Login
  },
	/* ----------------------------------- 身分驗證結果 ------------------------------------- */
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
	/* ----------------------------------- OTP驗證 ------------------------------------- */
  {
    path: '/otp-verify',
    name: 'OTPVerify',
    component: OTPVerify
  },
	/* ----------------------------------- 身分驗證失敗 ------------------------------------- */
  {
    path: '/application-callin-error',
    name: 'ApplicationCallinError',
    component: ApplicationCallinError,
    redirect: '/application-callin-error/03',
    children: [
      {
        path: '03',
        name: 'Error03',
        component: () => import('@/pages/error/Error03.vue')
      },
			{
        path: '04',
        name: 'Error04',
        component: () => import('@/pages/error/Error04.vue')
      },
			{
        path: '05',
        name: 'Error05',
        component: () => import('@/pages/error/Error05.vue')
      },
			{
        path: '500',
        name: 'Error500',
        component: () => import('@/pages/error/Error500.vue')
      },
			{
        path: 'maintenance',
        name: 'ErrorMaintenance',
        component: () => import('@/pages/error/ErrorMaintenance.vue')
      }
    ]
  },
	/* ----------------------------------- 申請完成 ------------------------------------- */
  {
    path: '/application-completed',
    name: 'ApplicationCompleted',
    component: ApplicationCompleted
  },
	/* ----------------------------------- 申請失敗 ------------------------------------- */
  {
    path: '/application-failed',
    name: 'ApplicationFailed',
    component: ApplicationFailed
  },
	/* ----------------------------------- 連線逾時 ------------------------------------- */
  {
    path: '/application-timeout',
    name: 'ApplicationTimeout',
    component: ApplicationTimeout
  },
	/* ----------------------------------- 轉頁 ------------------------------------- */
  {
    path: '/dispatch',
    name: 'DispatchEmptyPage',
    component: DispatchEmptyPage
  },
	/* ----------------------------------- 投保流程 ------------------------------------- */
  {
		path: '/insure',
		name: 'InsureEmptyRouter',
		component: InsureEmptyRouter,
    redirect: '/insure/step1',
    children: [
      {
        path: 'step1',
        name: 'InsureStep1',
        component: () => import('@/pages/Insure/Insure_step1.vue')
      },
			{
        path: 'step2',
        name: 'InsureStep2',
        component: () => import('@/pages/Insure/Insure_step2.vue')
      },
			{
        path: 'step3',
        name: 'InsureStep3',
        component: () => import('@/pages/Insure/Insure_step3.vue')
      },
			{
        path: 'step4',
        name: 'InsureStep4',
        component: () => import('@/pages/Insure/Insure_step4.vue')
      },
    ]
	},
];



const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  Vue.prototype.beforeEnter$.next({
    to,
    from
  });
  next();
});

export default router;
